import { render } from "./EntranceExitShow.vue?vue&type=template&id=70b9d08e&scoped=true"
import script from "./EntranceExitShow.vue?vue&type=script&lang=js"
export * from "./EntranceExitShow.vue?vue&type=script&lang=js"

import "./EntranceExitShow.vue?vue&type=style&index=0&id=70b9d08e&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b9d08e"]])

export default __exports__